import script from "./input.vue?vue&type=script&setup=true&lang=js"
export * from "./input.vue?vue&type=script&setup=true&lang=js"

import "./input.vue?vue&type=style&index=0&id=636cfd8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636cfd8c"]])

export default __exports__